/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddressFilterOption {
    ALL = 'All',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}
